<template layout="auth">
	<div class="space-y-5">
		<p>{{ t('app.auth.unattached.description') }}</p>

		<button-base :href="route('logout')" variant="secondary" method="POST">
			{{ t('app.logout') }}
		</button-base>
	</div>
</template>
